import React from 'react';
import Eyebrow from '../motion/Eyebrow';
import KineticHeadline from '../motion/KineticHeadline';
import Reveal from '../motion/Reveal';
import FilmPlayer from '../motion/FilmPlayer';
import SectionLight from '../motion/SectionLight';
import Claws from '../motion/Claws';

/** The launch film as a feathered strip of the page. */
export default function FilmSection() {
  return (
    <section className="pnp-section pnp-film-section" aria-label="Launch film">
      <SectionLight bleed="60px">
        <div className="pnp-glow pnp-glow-center" style={{ top: '18%', opacity: 0.7 }} />
      </SectionLight>
      <div className="pnp-wrap pnp-center pnp-head">
        <Eyebrow>The launch film</Eyebrow>
        <KineticHeadline text={'This is *fight night.*'} />
        <Reveal delay={200}>
          <p className="pnp-lead">Lock your picks, watch the leaderboard move as results land, and settle it in the chat.</p>
        </Reveal>
      </div>
      <Reveal delay={150} className="pnp-film-stage pnp-scroll-scale">
        <Claws className="pnp-film-claws" />
        <FilmPlayer />
      </Reveal>
    </section>
  );
}
